import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Loader2, ArrowRight, Calendar } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="mb-10">
          <p className="text-sm text-slate-500 uppercase tracking-wider mb-1">Blog</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#00133F]">Inspirasi & Tips Cetak</h1>
          <p className="text-slate-600 mt-3 max-w-lg">Ide desain, panduan produk, dan tips memaksimalkan cetak kustommu.</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 animate-spin text-[#F0005A]" /></div>
        ) : posts.length === 0 ? (
          <p className="text-slate-500 text-center py-24">Belum ada artikel.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                  className="group block rounded-2xl overflow-hidden border border-slate-200 bg-white hover:shadow-[0_20px_50px_rgb(10,25,47,0.1)] hover:-translate-y-1 transition-all duration-300 h-full flex flex-col">
                  {p.cover_image && (
                    <div className="aspect-[16/10] overflow-hidden bg-slate-50">
                      <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    </div>
                  )}
                  <div className="p-6 flex flex-col flex-1">
                    <div className="flex items-center gap-1.5 text-xs text-slate-400 mb-2">
                      <Calendar className="w-3.5 h-3.5" />
                      {new Date(p.created_at).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" })}
                    </div>
                    <h3 className="font-heading text-lg font-semibold text-[#00133F] leading-snug">{p.title}</h3>
                    <p className="text-sm text-slate-500 mt-2 line-clamp-3 flex-1">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center text-sm font-medium text-[#F0005A]">
                      Baca selengkapnya <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
